import type {Dispatch} from "redux";

import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import {getExternalRequest} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {apiBigDataLink} from "@pg-mono/rp-api-routes";

import {bigDataApiUrl} from "../../../app/read_rp_environment_variables";
import type {IPricesAvailableDate} from "../types/IPricesAvailableDate";

const FETCH_PRICES_AVAILABLE_DATE = "reports/FETCH_PRICES_AVAILABLE_DATE";

export const fetchPricesAvailableDateTypes = createRequestActionTypes(FETCH_PRICES_AVAILABLE_DATE);

export const fetchPricesAvailableDate = () => async (dispatch: Dispatch) => {
    dispatch({type: fetchPricesAvailableDateTypes.start});

    const url = apiBigDataLink.currentDate.base(bigDataApiUrl);

    // No matter what, return `true` from this request - next actions will use response from this request or calculate date range by current date.
    return getExternalRequest({}, url, 5000)
        .then((response: IPricesAvailableDate) => {
            dispatch({type: fetchPricesAvailableDateTypes.success, result: response});

            return true;
        })
        .catch((error) => {
            notifyBugsnagClient(error, "");

            dispatch({type: fetchPricesAvailableDateTypes.error});

            return true;
        });
};
import type {Dispatch} from "redux";

import {notifyBugsnagClient} from "@pg-mono/bugsnag-client";
import {getExternalRequest} from "@pg-mono/request";
import {createRequestActionTypes} from "@pg-mono/request-state";
import {apiBigDataLink} from "@pg-mono/rp-api-routes";

import {bigDataApiUrl} from "../../../app/read_rp_environment_variables";
import type {IPricesAvailableDate} from "../types/IPricesAvailableDate";

const FETCH_PRICES_AVAILABLE_DATE = "reports/FETCH_PRICES_AVAILABLE_DATE";

export const fetchPricesAvailableDateTypes = createRequestActionTypes(FETCH_PRICES_AVAILABLE_DATE);

export const fetchPricesAvailableDate = () => async (dispatch: Dispatch) => {
    dispatch({type: fetchPricesAvailableDateTypes.start});

    const url = apiBigDataLink.currentDate.base(bigDataApiUrl);

    // No matter what, return `true` from this request - next actions will use response from this request or calculate date range by current date.
    return getExternalRequest({}, url, 5000)
        .then((response: IPricesAvailableDate) => {
            dispatch({type: fetchPricesAvailableDateTypes.success, result: response});

            return true;
        })
        .catch((error) => {
            notifyBugsnagClient(error, "");

            dispatch({type: fetchPricesAvailableDateTypes.error});

            return true;
        });
};
